import { css } from '@emotion/css';

import {
  EXTRA_LARGE_DEVICE_MQ,
  LARGE_DEVICE_MQ,
  MEDIUM_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const cardPostsClassName = css({
  paddingBottom: Spacing.XL,
  paddingTop: Spacing['3XL'],
});

export const layoutClassName = css({
  display: 'grid',
  gridAutoRows: 20,
  gridGap: 0,
  gridTemplateColumns: `repeat(auto-fit, minmax(20rem, 1fr))`,
  margin: `-${Spacing.XS}px`,
  [MEDIUM_DEVICE_MQ]: {
    gridTemplateColumns: `repeat(auto-fit, minmax(18rem, 50%))`,
  },
  [LARGE_DEVICE_MQ]: {
    gridTemplateColumns: `repeat(auto-fit, minmax(18rem, 33.33333%))`,
  },
  [EXTRA_LARGE_DEVICE_MQ]: {
    gridTemplateColumns: `repeat(auto-fit, minmax(18rem, 25%))`,
  },
});

export const layoutItemClassName = css({
  display: 'block',
  margin: Spacing.XS,
  position: 'relative',
});
